import { z } from 'zod';
import { BaseValidations } from '@anytag/shared-validations';

export const SignInFormSchema = z.object({
  email: BaseValidations.EmailSchema,
  password: BaseValidations.PasswordSchema
});
